import { request } from '../request'

export const boletin = {
  getBoletinByAreas: function (idModel: string) {
    return request.get(`boletin/getBoletinTexto?model=${idModel}`)
  }
}
